import { createPendingQueueStore } from '../lib/pendingQueue.js';
import type { ExamResultPayload } from './results.js';

/**
 * Offline buffer for finished exam sittings — the task queue's twin
 * (`pendingExamTaskStore.ts`). QUEUE-FIRST: a finished sitting is enqueued
 * before the RPC attempt and removed on success, so closing the app or
 * losing the network never loses it. `save_exam_result` is idempotent per
 * attempt, so a double-send (direct call + flusher racing) is harmless.
 */

export interface PendingExamResult {
  /** The attempt id. */
  id: string;
  payload: ExamResultPayload;
  userId: string;
  queuedAt: number;
  attempts?: number;
  lastAttemptAt?: number;
}

export const usePendingExamResultStore = createPendingQueueStore<{
  results: PendingExamResult;
}>({
  storageKey: 'fluent.pending-exam-results.v1',
  collections: { results: (r) => r.id },
});
